// Biblioteca Lu.ft — a permanent, editorial video library extending the studio.
// Substitute `vimeoId` with the real Vimeo IDs when each film is uploaded.

export const LIBRARY_VIDEOS = [
  {
    id: "morning-mobility",
    title: "Morning Mobility",
    duration: "18 min",
    level: "Todos os níveis",
    teacher: "Lu.ft Studio",
    description:
      "Despertar consciente — articulações, respiração e atenção. Para começar o dia em ritmo lento.",
    poster: "/media/luft-yoga-practice.jpg",
    vimeoId: null,
  },
  {
    id: "core-flow",
    title: "Core Flow",
    duration: "25 min",
    level: "Intermédio",
    teacher: "Lu.ft Studio",
    description:
      "Trabalho de centro com transições fluidas e sequência matwork. Calor consciente, sem pressa.",
    poster: "/media/luft-matwork-practice.jpg",
    vimeoId: null,
  },
  {
    id: "travel-reset",
    title: "Travel Reset",
    duration: "20 min",
    level: "Todos os níveis",
    teacher: "Lu.ft Studio",
    description:
      "Pensada para quartos de hotel e dias em movimento. Mobilidade, alongamento e regresso ao corpo.",
    poster: "/media/luft-detail-shoulder.jpg",
    vimeoId: null,
  },
  {
    id: "breath-release",
    title: "Breath & Release",
    duration: "15 min",
    level: "Todos os níveis",
    teacher: "Lu.ft Studio",
    description:
      "Respiração, descompressão e libertação de tensão. Encerrar o dia com presença.",
    poster: "/media/luft-yoga-stillife.jpg",
    vimeoId: null,
  },
];
